module.exports = __webpack_public_path__ + "img/ed-start-mobile.fca9a600.png";